<template>
  <div>
    <v-tabs v-model="tab" class="tabWithoutSlideIndicator">
      <v-tab :key="'schedules'" :href="`#tab-schedules`">{{$t('gameoverview.tab.game-schedule')}}</v-tab>

      <v-tab-item :value="'tab-schedules'">
        <div v-if="this.game.state == 'created' || this.game.state == 'checkin'">
          <game-info :game="game" :showDescription="false" :showLegal="false"/>
        </div>
        <schedule v-else :game="game" />
      </v-tab-item>
    </v-tabs>
  </div>
</template>

<script>
import {} from "@/plugins/store";
import Schedule from "@/widgets/Schedule";
import GameInfo from "@/widgets/GameInfo";

export default {
  name: "KoMixedGamePublic",
  components: {
    GameInfo,
    Schedule
  },
  props: {
    game: {
      type: Object,
      required: true
    },
    tabKey: {
      type: String,
      required: false
    }
  },
  data: function() {
    return {
      tab: undefined
    };
  },
  watch: {
    game: function() {
      console.log("game changed");
    },
  }
};
</script>

<style scoped>
.tabWithoutSlideIndicator >>> .v-slide-group__prev {
  display: none !important;
}
</style>
